<template>
  <div class="traceability-main-view width-responsiveness">
    <sub-header
      title="Minha Rotina"
      updated-time
      icon-path="/static/images/icon-tubes.svg"
      back-router-name="Dashboard"
    />

    <button
      class="routine-help-button"
      @click="openHelpModal"
    >
      <md-tooltip md-direction="left">Clique aqui e saiba mais</md-tooltip>
      <svg-loader
        src="/static/images/icon-help-basic-purple.svg"
        class="mr-1"
      />
    </button>

    <!-- Filtros -->
    <traceability-filter />

    <tabs
      :tab-selected="traceabilityCurrentTab"
      class="mt-2 mb-2"
      with-border
      :tabs="tabs"
      :content-loading="isCountersLoading"
      @tabClicked="onTabChange"
    />

    <!-- Conteúdo principal -->
    <div>
      <div v-if="traceabilityOrders.length > 0">
        <traceability-data-table
          :grouped-exams="traceabilityOrders"
          @examIncluded="handleExamIncluded"
        />
      </div>

      <div
        v-else-if="traceabilityOrdersLoadingStatus === 'STATUS_FINISHED'"
        class="empty-search"
      >
        <svg-loader src="/static/images/icon-no-tubes-found.svg" />
        <p>Não encontramos nenhum resultado para sua busca.</p>
      </div>

      <div
        v-else-if="
          traceabilityOrdersLoadingStatus === 'STATUS_LOADING' &&
          traceabilityOrders.length === 0
        "
        class="flex justify-center align-center"
      >
        <spinner class="loader-table" />
      </div>
    </div>

    <TraceabilityAlert
      ref="traceabilityAlert"
      :show-timer="showAlertTimer"
      @modal-closed="onModalClosed"
    />
  </div>
</template>

<script>
import Card from '@/components/Dashboard/Card'
import TraceabilityDataTable from './TraceabilityDataTable'
import TraceabilityFilter from './TraceabilityFilter'
import Spinner from '../common/Spinner'
import { mapGetters, mapActions } from 'vuex'
import { TRACEABILITY_SEARCH_DATE } from '@/enums'
import Moment from 'moment'
import strings from '@/strings'
import Tabs from '../common/Tabs.vue'
import SubHeader from '../common/SubHeaderV2.vue'
import TraceabilityAlert from './TraceabilityAlert.vue'

export default {
  name: 'TraceabilityMainView',
  components: {
    Card,
    TraceabilityFilter,
    Spinner,
    Tabs,
    SubHeader,
    TraceabilityDataTable,
    TraceabilityAlert,
  },
  data() {
    return {
      sortBy: null,
      minutes: 0,
      status: strings.traceabilityStatus,
      updateTime: new Date(),
      showAlertTimer: true,
      options: [
        { value: 'motivo', label: 'Motivo' },
        { value: 'os_alvaro', label: 'OS Álvaro' },
        { value: 'date', label: 'Prazo da Resolução' },
        { value: 'status', label: 'Status' },
        { value: 'os_lis', label: 'OS Lis' },
        { value: 'batch', label: 'Lote' },
      ],
    }
  },

  computed: {
    ...mapGetters([
      'toggle',
      'traceabilityOrders',
      'traceabilityOrdersLoadingStatus',
      'traceabilityCountersLoadingStatus',
      'totalSamplesInScreening',
      'totalDelayedExamsCount',
      'traceabilityCurrentTab',
      'traceabilityGroupedExamsCount',
      'traceabilityTotalCount',
      'traceabilityFilterState',
    ]),

    isCountersLoading() {
      return this.traceabilityCountersLoadingStatus === 'STATUS_LOADING'
    },

    tabs() {
      return [
        {
          name: 'TODOS',
          key: 'TODOS',
          total: this.traceabilityTotalCount ?? 0,
          tooltip: 'Todos os exames',
        },
        {
          name: 'CADASTRADOS',
          key: 'CADASTRADO',
          total: this.traceabilityGroupedExamsCount?.CADASTRADO ?? 0,
          tooltip: 'Exames cadastrados',
        },
        {
          name: 'EM TRÂNSITO',
          key: 'EM_TRANSITO',
          total: this.traceabilityGroupedExamsCount?.EM_TRANSITO ?? 0,
          tooltip: 'Exames em trânsito',
        },
        {
          name: 'ENTREGUES AO NTO',
          key: 'TRIAGEM',
          total: this.traceabilityGroupedExamsCount?.TRIAGEM ?? 0,
          tooltip: 'Exames entregues ao NTO',
        },
        {
          name: 'EM EXECUÇÃO',
          key: 'EM_EXECUCAO',
          total: this.traceabilityGroupedExamsCount?.EM_EXECUCAO ?? 0,
          tooltip: 'Exames em execução',
        },
        {
          name: 'LIBERADOS',
          key: 'FINALIZADO',
          total: this.traceabilityGroupedExamsCount?.FINALIZADO ?? 0,
          tooltip: 'Exames liberados',
        },
        {
          name: 'ATRASADOS',
          key: 'ATRASADO',
          total: this.traceabilityGroupedExamsCount?.ATRASADO ?? 0,
          tooltip: 'Exames em atraso',
        },
        {
          name: 'CANCELADOS',
          key: 'CANCELADO',
          total: this.traceabilityGroupedExamsCount?.CANCELADO ?? 0,
          tooltip: 'Exames cancelados',
        },
        {
          name: 'RECOLETAS',
          key: 'RECOLETADO',
          total: this.traceabilityGroupedExamsCount?.RECONVOCADO ?? 0,
          tooltip: 'Recoleta solicitada',
        },
      ]
    },
  },
  created() {
    this.resetTraceabilityPagination()
    this.getInitialFilters()
  },
  beforeDestroy() {
    this.resetTraceabilityStore()
  },
  methods: {
    ...mapActions([
      'selectTraceabilityParams',
      'setCurrentTabTraceability',
      'getTotalTraceabilityStatus',
      'getTraceabilityGroupedExams',
      'getTraceabilityGetGroupedExamsCount',
      'resetTraceabilityStore',
      'resetTraceabilityPagination',
    ]),
    handleExamIncluded({ orderId, examData }) {
      this.$emit('examIncluded', { orderId, examData })
    },

    getFilterDefault() {
      let today = Moment(new Date()).format('DD/MM/YYYY')
      this.$router.push({
        path: this.$route.path,
        query: {
          startDate: today,
          endDate: today,
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
        },
      })
    },
    getInitialFilters() {
      if (this.hasUrlParameters()) {
        this.initializeFromUrlParameters()
      } else {
        this.initializeWithDefaults()
      }
    },

    hasUrlParameters() {
      return !!this.$route.query
    },

    initializeFromUrlParameters() {
      this.selectTraceabilityParams(this.$router.history.current.query)
      this.executeSearch()
      this.loadCounters()
      this.setActiveTabFromUrl()
    },

    initializeWithDefaults() {
      const defaultParams = {
        typeOfSearch: 'PN',
        q: '',
        status: '',
        startDate: null,
        endDate: null,
      }

      this.selectTraceabilityParams(defaultParams)
      this.executeSearch()
      this.loadCounters()
    },

    executeSearch() {
      this.getTraceabilityGroupedExams()
    },

    loadCounters() {
      this.getTraceabilityGetGroupedExamsCount()
    },

    setActiveTabFromUrl() {
      const status = this.$route.query.status
      if (!status) return

      this.$nextTick(() => {
        const tabIndex = this.tabs.findIndex(tab => tab.key === status)
        if (tabIndex !== -1) {
          this.setCurrentTabTraceability(tabIndex)
        }
      })
    },
    onTabChange(index) {
      this.setCurrentTabTraceability(index)
      const selectedTab = this.tabs[index]
      if (selectedTab && selectedTab.key) {
        let params

        if (selectedTab.key === 'TODOS') {
          params = this.buildTodosTabParams()
        } else {
          params = this.buildRegularTabParams(selectedTab.key)
        }

        this.selectTraceabilityParams(params)
        this.resetTraceabilityPagination()
        this.getTraceabilityGroupedExams({ clearDataFirst: true })

        this.updateUrlWithStatus(selectedTab.key)
      }
    },

    buildTodosTabParams() {
      const currentFilter = this.traceabilityFilterState

      return {
        typeOfSearch: currentFilter.typeOfSearch || 'PN',
        q: currentFilter.query || '',
        startDate: currentFilter.startDate,
        endDate: currentFilter.endDate,
        status: '',
        placeExecution: currentFilter.placeExecution || '',
      }
    },

    buildRegularTabParams(statusKey) {
      const currentTypeOfSearch = this.$route.query.typeOfSearch || 'PN'
      const params = {
        typeOfSearch: currentTypeOfSearch,
        status: statusKey,
      }

      if (currentTypeOfSearch === TRACEABILITY_SEARCH_DATE) {
        params.startDate = this.$route.query.startDate || null
        params.endDate = this.$route.query.endDate || null
        params.q = ''
      } else {
        params.q = this.$route.query.q || ''
        params.startDate = null
        params.endDate = null
      }

      return params
    },

    updateUrlWithStatus(status) {
      const query = { ...this.$route.query }

      if (status === 'TODOS') {
        delete query.status
      } else {
        query.status = status
      }

      this.$router.push({
        path: this.$route.path,
        query: query,
      })
    },

    openHelpModal() {
      this.showAlertTimer = false
      this.$nextTick(() => {
        this.$refs.traceabilityAlert.openTraceabilityAlertModalWithoutTimer()
      })
    },

    onModalClosed() {
      // Resetar o estado do timer para futuras aberturas automáticas
      this.showAlertTimer = true
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.traceability-main-view {
  height: 100vh;
  padding-top: $mainHeaderHeight !important;
  margin-top: 85px;

  .loader-table {
    margin-top: 15%;
    margin-left: auto;
  }

  .empty-search {
    width: 20%;
    position: relative;
    top: 35%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 35%;
    }

    p {
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  .search-title {
    display: flex;

    div {
      display: flex;
    }

    .md-icon {
      cursor: pointer;
      margin-right: 0.7em;
    }
  }

  .subheader__content__right-side {
    display: flex;

    .subheader-alternative-actions-container {
      position: inherit;
    }

    p {
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7a7a7a;
      margin: auto;
    }
  }

  .routine-help-button {
    display: inline-flex;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 36px;
    top: 82px;
    z-index: 11;

    .md-icon {
      width: 22px;
      min-width: 22px;
      height: 22px;
      min-height: 22px;
      font-size: 22px;
      padding: 0 !important;
    }

    svg-loader {
      width: 22px;
      height: 22px;
    }
  }
}
</style>
